import React, { Component } from 'react'
import {
    Modal, Button, Select, Form, Col, Row, Input
} from 'antd';
import { Table } from 'react-bootstrap';
import Firebase from '../Firebase';
import Questions from './Questions.json';
const { Option } = Select;
export class Sc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            InputName: '',
            Answer: [0, 0, 0, 0, 0,],//5,
            CreateDate: new Date(),
            visible: false,
            question1: [],
            question2: [],
            question3: [],
            question4: [],
            question5: [],
            schools: [],
            SchoolID: '',
            textscore: ['1', '2', '3', '4', '5']
        }
    }
    componentDidMount() {

    }
    ans(id, value) {
        let Answer = this.state.Answer;
        Answer[id] = value;
        console.log(id, '=', value);
        this.setState({
            Answer
        })

    }
    getListSchool = (querySnapshot) => {
        const schools = [];
        querySnapshot.forEach((doc) => {


            if (doc.data().status !== undefined) {
                if (doc.data().status === false) {

                    schools.push({ ID: doc.id, ...doc.data() });
                }
            } else {
                schools.push({ ID: doc.id, ...doc.data() });
            }
        })

        this.setState({
            schools
        })
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { SchoolID, Answer, CreateDate, InputName } = this.state;
        Firebase.firestore().collection('SCSCORE').add({
            SchoolID, Answer, CreateDate, InputName
        }).then((doc) => {
            alert(" success")
            this.setState({
                SchoolID: '',
                Answer: [0, 0, 0, 0, 0,]
            })

        }).catch((error) => {
            console.log(error)
        })
    }
    onSelect = (Version) => {
        Firebase.firestore().collection('Schools').where('Version', '==', Version).onSnapshot(this.getListSchool);
    }
    render() {
        const { Answer, CreateDate, textscore, InputName } = this.state;
        return (
            <form style={{ margin: 20 }}
                onSubmit={this.onSubmit}
            >
                <Modal
                    cancelButtonProps={{ style: { display: 'none' } }}
                    title="เกณฑ์การพิจารณาประกวดโครงการ"
                    visible={this.state.visible}
                    okText="ตกลง"
                    onOk={() => this.setState({ visible: false })}
                >
                    <p>โครงการ พัฒนานวัตกรรมสร้างสรรค์และแกนนำเยาวชนนักตรวจสอบทุจริตคอรัปชัน</p>
                </Modal>
                <div style={{
                    backgroundColor: '#ffaaee', width: '100%', height: '100%', borderRadius: 5, padding: 10
                }}>
                    <h3 style={{ textAlign: 'center' }}><strong>เกณฑ์การพิจารณาประกวดโครงการ</strong></h3>
                    <p style={{ textAlign: 'center', fontSize: 18 }}>วันที่{CreateDate.getDate() + "/" + (CreateDate.getMonth() + 1) + "/" + CreateDate.getFullYear()}</p>
                </div>
                <div style={{
                    borderRadius: 5, padding: 5, justifyContent: 'center', display: 'flex'
                }}>
                    <Select style={{ width: 'auto', minWidth: 250 }} onChange={(str) => this.onSelect(str)} placeholder="เลือกรุ่น" >
                        <Option key={0} value="1">รุ่นที่ 1</Option>
                        <Option key={1} value="2">รุ่นที่ 2</Option>
                        <Option key={2} value="3">รุ่นที่ 3</Option>

                    </Select>

                </div>
                <div style={{
                    borderRadius: 5, padding: 5, justifyContent: 'center', display: 'flex'
                }}>
                    <Select style={{ width: 'auto', minWidth: 250 }} onChange={(str) => this.setState({ SchoolID: str })} placeholder="เลือกโรงเรียน" >
                        {this.state.schools.map((element, i) =>
                            // console.log(element.Name)
                            <Option key={i} value={element.ID}>{element.Name}</Option>

                        )}
                    </Select>
                </div>
                <div style={{
                    borderRadius: 5, padding: 5, justifyContent: 'center', display: 'flex'
                }}>
                    <center>
                        <Input required name="InputName" onChange={(str) => this.setState({ InputName: str.target.value })}
                            placeholder="ใส่ชื่อจริง-นามสกุล" style={{ width: 275 }}
                        ></Input>
                    </center>
                </div>



                {this.state.SchoolID !== '' && InputName !== '' && < div style={{
                    width: '100%', height: '100%', borderRadius: 5, padding: 10
                }}>

                    <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th rowSpan="2" style={{ verticalAlign: 'top', textAlign: 'center' }}>ประเมินผลกิจกรรม</th>
                                <th colSpan="5">ระดับ</th>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'center' }}>1</th>
                                <th style={{ textAlign: 'center' }}>2</th>
                                <th style={{ textAlign: 'center' }}>3</th>
                                <th style={{ textAlign: 'center' }}>4</th>
                                <th style={{ textAlign: 'center' }}>5</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={101}>

                                <td colSpan={1} style={{ backgroundColor: '#aaffff' }}><strong>1.  ด้านความคุ้มค่ากับงบประมาณ</strong></td>
                                <td rowSpan={2} >
                                    <input required type="radio" name={"Q1"} style={{ margin: 5 }} onChange={this.ans.bind(this, 0, textscore[0])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q1"} style={{ margin: 5 }} onChange={this.ans.bind(this, 0, textscore[1])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q1"} style={{ margin: 5 }} onChange={this.ans.bind(this, 0, textscore[2])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q1"} style={{ margin: 5 }} onChange={this.ans.bind(this, 0, textscore[3])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q1"} style={{ margin: 5 }} onChange={this.ans.bind(this, 0, textscore[4])} />
                                </td>
                            </tr>
                            <tr>
                                <td>กิจกรรมมีความหลากหลายและมีจำนวนกลุ่มเป้าหมายสอดคล้องกับงบประมาณ รวมถึงเกิดผลลัพธ์ตามที่กำหนดไว้ในโครงการ</td>
                            </tr>
                            <tr key={102}>
                                <td colSpan={1} style={{ backgroundColor: '#aaffff' }}><strong>2.	ความสอดคล้องกับประเด็นของโครงการหลัก </strong></td>
                                <td rowSpan={2} >
                                    <input required type="radio" name={"Q2"} style={{ margin: 5 }} onChange={this.ans.bind(this, 1, textscore[0])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q2"} style={{ margin: 5 }} onChange={this.ans.bind(this, 1, textscore[1])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q2"} style={{ margin: 5 }} onChange={this.ans.bind(this, 1, textscore[2])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q2"} style={{ margin: 5 }} onChange={this.ans.bind(this, 1, textscore[3])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q2"} style={{ margin: 5 }} onChange={this.ans.bind(this, 1, textscore[4])} />
                                </td>
                            </tr>
                            <tr>
                                <td>กิจกรรมในโครงการมีความสอดคล้องกับหลักการแนวคิดด้านการตรวจสอบ การป้องกัน และ รู้เท่าทันการทุจริตคอรัปชัน</td>
                            </tr>
                            <tr key={103}>
                                <td colSpan={1} style={{ backgroundColor: '#aaffff' }}><strong>3.	ด้านความคิดสร้างสรรค์</strong></td>
                                <td rowSpan={2} >
                                    <input required type="radio" name={"Q3"} style={{ margin: 5 }} onChange={this.ans.bind(this, 2, textscore[0])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q3"} style={{ margin: 5 }} onChange={this.ans.bind(this, 2, textscore[1])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q3"} style={{ margin: 5 }} onChange={this.ans.bind(this, 2, textscore[2])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q3"} style={{ margin: 5 }} onChange={this.ans.bind(this, 2, textscore[3])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q3"} style={{ margin: 5 }} onChange={this.ans.bind(this, 2, textscore[4])} />
                                </td>
                            </tr>
                            <tr>
                                <td>โครงการมีความแปลกใหม่ สร้างสรรค์ และ มีความน่าสนใจ</td>
                            </tr>
                            <tr key={104}>
                                <td colSpan={1} style={{ backgroundColor: '#aaffff' }}><strong>4.	ด้านการดำเนินงาน</strong></td>
                                <td rowSpan={2} >
                                    <input required type="radio" name={"Q4"} style={{ margin: 5 }} onChange={this.ans.bind(this, 3, textscore[0])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q4"} style={{ margin: 5 }} onChange={this.ans.bind(this, 3, textscore[1])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q4"} style={{ margin: 5 }} onChange={this.ans.bind(this, 3, textscore[2])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q4"} style={{ margin: 5 }} onChange={this.ans.bind(this, 3, textscore[3])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q4"} style={{ margin: 5 }} onChange={this.ans.bind(this, 3, textscore[4])} />
                                </td>
                            </tr>
                            <tr>
                                <td>โครงการและกิจกรรมที่เสนอสามารถทำได้จริงในพื้นที่</td>
                            </tr>
                            <tr key={105}>
                                <td colSpan={1} style={{ backgroundColor: '#aaffff' }}><strong>5.	ด้านการทำให้เกิดความยั่งยืน</strong></td>
                                <td rowSpan={2} >
                                    <input required type="radio" name={"Q5"} style={{ margin: 5 }} onChange={this.ans.bind(this, 4, textscore[0])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q5"} style={{ margin: 5 }} onChange={this.ans.bind(this, 4, textscore[1])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q5"} style={{ margin: 5 }} onChange={this.ans.bind(this, 4, textscore[2])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q5"} style={{ margin: 5 }} onChange={this.ans.bind(this, 4, textscore[3])} />
                                </td>
                                <td rowSpan={2}>
                                    <input type="radio" name={"Q5"} style={{ margin: 5 }} onChange={this.ans.bind(this, 4, textscore[4])} />
                                </td>
                            </tr>
                            <tr>
                                <td>โครงการที่เสนอมีโอกาศเกิดความยั่งยืนได้</td>
                            </tr>


                        </tbody>
                    </Table>
                    <div style={{ display: "flex", justifyContent: 'center' }}>
                        <button type="submit" className="btn btn-primary">บันทึก</button>

                    </div>
                    <br></br>


                </div>}

            </form>
        )
    }
}

export default Sc
